import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Breadcrumbs, LoadingOverlay, Text } from "@mantine/core";
import CloudForm from "./Clouds/CloudForm";
import DisplayCloud from "./Clouds/DisplayCloud";
export default function Clouds() {
    var _a = useState(null), items = _a[0], setItems = _a[1];
    var _b = useState(false), creating = _b[0], setCreating = _b[1];
    return _jsxs("div", { children: [_jsx(Breadcrumbs, { children: [
                    _jsx(Text, { size: "sm", c: "dimmed", children: "Home" }, 0),
                ] }), _jsx("h1", { children: "Clouds" }), _jsx(CloudForm, { onUpdate: setItems, onStartCreate: function () { return setCreating(true); }, onEndCreate: function () { return setCreating(false); } }), items !== null &&
                (creating
                    ? _jsx(LoadingOverlay, { visible: true, zIndex: 1000, overlayProps: { radius: "sm", blur: 2 } })
                    : _jsx(DisplayCloud, { items: items }))] });
}
